import {removeClass, slideToggle, addClass} from "./_classesHelper";

class Accordion {
  constructor() {
    this.ariaAttribute = "aria-expanded";
    this.collapsedClass = "js-collapsed";
    this.collapsingClass = "js-collapsing";
    this.collapseClass = "js-collapse";
    this.buttonCollapseClass = "js-btn-collapse";
    this.showClass = "js-show";
    this.alwaysShowOnScreenClass = "js-visible-md-up";
    this.collapseElementList = [].slice.call(
      document.querySelectorAll(`.${this.collapseClass}`)
    );
    this.breakpoint = "(min-width: 769px)";
    this.mediaQuery = window.matchMedia(this.breakpoint);
    if (this.collapseElementList && this.collapseElementList.length > 0) {
      this.init();
    }
  }

  init() {
    this.removeFunctionOnScreensize(this.mediaQuery);
    this.collapseActivation(this.collapseElementList, this.mediaQuery);

    window.addEventListener("resize", (event) => {
      this.mediaQuery = window.matchMedia(this.breakpoint);
      this.removeFunctionOnScreensize(this.mediaQuery);
    });
  }

  collapseActivation(elArray) {
    elArray.forEach((collapseEl) => {
      const parent = collapseEl.parentNode;
      const btn = parent.querySelector("button")
        ? parent.querySelector("button")
        : parent.querySelector(`.${this.buttonCollapseClass}`);
      if (btn) {
        btn.addEventListener("click", (e) => {
          if (collapseEl.classList.contains(this.collapseClass)) {
            this.changeAria(btn);
            this.changeClass(btn, collapseEl);
            slideToggle(collapseEl, 500);
          }
        });
      }

      const dropdownIcon = parent.querySelector(".dropdown-icon");
      if (dropdownIcon) {
        dropdownIcon.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === "Space" || e.key === "Spacebar" || e.key === " ") {
            e.preventDefault()
            if (collapseEl.classList.contains(this.collapseClass)) {
              this.changeAria(btn);
              this.changeClass(btn, collapseEl);
              slideToggle(collapseEl, 500);
            }
          }
        });
        dropdownIcon.addEventListener("click", (e) => {
          if (e.key === "Enter" || e.key === "Space") {
            if (collapseEl.classList.contains(this.collapseClass)) {
              this.changeAria(dropdownIcon);
              this.changeClass(dropdownIcon, collapseEl);
              slideToggle(collapseEl, 500);
            }
          }
        });
      }

      collapseEl.addEventListener("transitionrun", (e) => {
        if (e.propertyName === "height") {
          removeClass(collapseEl, this.collapseClass);
          addClass(collapseEl, this.collapsingClass);
        }
      });

      collapseEl.addEventListener("transitionend", (e) => {
        if (e.propertyName === "height") {
          removeClass(collapseEl, this.collapsingClass);
          addClass(collapseEl, this.collapseClass);
        }
      });

      collapseEl.addEventListener("transitioncancel", (e) => {
        if (e.propertyName === "height") {
          removeClass(collapseEl, this.collapsingClass);
          addClass(collapseEl, this.collapseClass);
        }
      });
    });
  }

  changeAria(el) {
    let ariaEl = el.getAttribute(this.ariaAttribute);
    let parameter = ariaEl === "false" ? "true" : "false";
    el.setAttribute(this.ariaAttribute, parameter);
  }

  changeClass(button, body) {
    button.classList.toggle(this.collapsedClass);
    body.classList.toggle(this.showClass);
  }

  //if element has class, remove the collapse class on screen size to avoid the toggling-effect
  removeFunctionOnScreensize(screensize) {
    this.collapseElementList.forEach((collapseEl) => {
      const hasShowClass = collapseEl.classList.contains(
        this.alwaysShowOnScreenClass
      );
      if (screensize.matches && hasShowClass) {
        removeClass(collapseEl, this.collapseClass);
        collapseEl.style.removeProperty("display");
      } else if (hasShowClass && !screensize.matches) {
        addClass(collapseEl, this.collapseClass);
      }
    });
  }
}

export default Accordion;
